import { useI18n } from 'next-localization';

import { GenericModal } from '@/components/modals';

import { TIME_REMAINING_MODAL } from '../constants';

export const TimeRemainingModal = (): JSX.Element => {
  const { t } = useI18n();
  return (
    <GenericModal
      hideDecline
      acceptButtonText={t('OAS.Common.Okay')}
      name={TIME_REMAINING_MODAL}
      label=""
    >
      <h3 className="mb-4">{t('OAS.Booking.Appointment.TimeRemainingModal.Title')}</h3>
      <p>{t('OAS.Booking.Appointment.TimeRemainingModal.Text')}</p>
    </GenericModal>
  );
};
